import { c as _c } from "react/compiler-runtime";
// Copied from find-contractors/[city]/_hooks/useInfiniteScroll.js (itself
// copied from (main_app)/lead-gen-profiles) — not promoted to a shared
// location since it's still only used within one route group's own pages.
import { useEffect, useRef } from "react";
export const useInfiniteScroll = (fetchNextPage, hasNextPage, isFetchingNextPage, t0) => {
  const $ = _c(6);
  const threshold = t0 === undefined ? 0.1 : t0;
  const loadMoreRef = useRef(null);
  const lastFetchTimeRef = useRef(0);
  const isIntersectingRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== fetchNextPage || $[1] !== hasNextPage || $[2] !== isFetchingNextPage || $[3] !== threshold) {
    t1 = () => {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        const now = Date.now();
        const timeSinceLastFetch = now - lastFetchTimeRef.current;
        const wasIntersecting = isIntersectingRef.current;
        isIntersectingRef.current = entry.isIntersecting;
        const shouldFetch = entry.isIntersecting && hasNextPage && !isFetchingNextPage && timeSinceLastFetch > 1000 && (!wasIntersecting || timeSinceLastFetch > 2000);
        if (shouldFetch) {
          lastFetchTimeRef.current = now;
          fetchNextPage();
        }
      }, {
        threshold,
        rootMargin: "100px"
      });
      const currentRef = loadMoreRef.current;
      if (currentRef) {
        observer.observe(currentRef);
      }
      return () => {
        if (currentRef) {
          observer.unobserve(currentRef);
        }
      };
    };
    t2 = [hasNextPage, isFetchingNextPage, fetchNextPage, threshold];
    $[0] = fetchNextPage;
    $[1] = hasNextPage;
    $[2] = isFetchingNextPage;
    $[3] = threshold;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return loadMoreRef;
};